import './MissionDescription.css';

const MissionDescription = () => { 
 

  return (

<div id='MissionDescriptionMainDiv'> 
      
  <h2 class="MissionDescriptionHeader">Naszą misją jest odkrywanie i rozwijanie talentów oraz kształtowanie sprawnych, pewnych siebie sportowców.</h2>

   <p class="MissionDescriptionParaf">
      Na początku drogi stawiamy na wszechstronne szkolenie i preselekcję, dzięki której młodzi zawodnicy mogą znaleźć konkurencję najlepiej dopasowaną do swoich możliwości i predyspozycji.
   </p> 

   <p class="MissionDescriptionParaf">
      Pracujemy pod okiem trenerów z ogromnym doświadczeniem, a fundamentem akademii jest ponad 40 lat pracy trenerskiej Edwarda Szymczaka – wybitnego polskiego szkoleniowca, wychowawcy zawodników, którzy odnosili sukcesy na arenie międzynarodowej i światowej w lekkiej atletyce, ze szczególnym uwzględnieniem skoku o tyczce.
   </p> 

   <p class="MissionDescriptionParaf">
     Wierzymy, że lekka atletyka to nie tylko sport, ale fundament wszechstronnego rozwoju – fizycznego, mentalnego i osobistego.
   </p> 

    </div>
  );
};

export default MissionDescription;